// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__i852H","text":"styles_text__Bl_DU"};